<template>
  <div class="vqb-group" :class="classObject">
    <div class="vqb-group-heading" :class="{ 'mycard-header': styled }">
      <div class="match-type-container" :class="{ 'form-inline': styled }">
        <div :class="{ 'form-group': styled }">
          <div role="radiogroup" class="btn-group-toggle btn-group btn-sm" style="z-index:1;">
            <label
              class="btn btn-sm"
              :class="{active : label.id == query.logicalOperator, 'btn-outline-primary': (depth % 1) == 0, 'btn-outline-success': (depth % 2) == 0, 'btn-outline-danger': (depth % 3) == 0 }"
              v-for="(label, index) in labels.matchTypes"
              :key="index"
            >
              <input type="radio" v-model="query.logicalOperator" :value="label.id">
              <span>{{label.label}}</span>
            </label>
          </div>
        </div>
        <div class="rule-actions" :class="{ 'form-inline': styled }">
          <div :class="{ 'form-group': styled }">
            <b-dropdown class="mr-2" size="sm">
              <template slot="button-content">
                <i class="icon-plus"/>
                {{$t(labels.addRule)}}
              </template>
              <b-dropdown-item
                v-for="(rule, index) in rules"
                :key="index"
                @click="selectedRule = rule;addRule()"
              >{{ rule.label }}</b-dropdown-item>
            </b-dropdown>
            <b-button
              size="sm"
              v-if="this.depth < this.maxDepth"
              @click="addGroup"
              :class="{'mr-2': this.depth == 1}"
            >
              <i class="icon-plus"/>
              {{$t(labels.addGroup)}}
            </b-button>
            <b-button v-if="this.depth == 1 && !query.then" @click="addThen" size="sm">
              <i class="icon-plus"/>
              {{$t(labels.addThen)}}
            </b-button>
          </div>
          <button
            type="button"
            :class="{ 'close pull-right': styled }"
            v-if="this.depth > 1"
            @click="remove"
            v-html="labels.removeGroup"
          ></button>
        </div>
      </div>
    </div>

    <div class="vqb-group-body" :class="{ 'mycard-body': styled }">
      <div class="children" :class="{ 'dashed': query.logicalOperator == 'or' }">
        <component
          v-for="(child, index) in query.children"
          :key="index"
          :is="child.type"
          :type="child.type"
          :query.sync="child.query"
          :ruleTypes="ruleTypes"
          :rules="rules"
          :rule="ruleById(child.query.rule)"
          :index="index"
          :maxDepth="maxDepth"
          :depth="depth + 1"
          :styled="styled"
          :labels="labels"
          v-on:child-deletion-requested="removeChild"
        ></component>
      </div>
      <div class="then mt-2" v-if="this.depth == 1 && query.then" style="margin-left: -10px;">
        <div class="form-inline">
          <div :class="{ 'form-group': styled }">
            <label class="vqb-label">{{ $t(labels.ifTrue) }}</label>
            <select :class="{ 'form-control': styled }" v-model="query.then.value">
              <option value="1">{{ $t("Ticket is accepted") }}</option>
              <option value="2">{{ $t("Ticket is rejected") }}</option>
              <option value="3">{{ $t("Ticket is sent for manual authorization") }}</option>
            </select>
            <input
              :class="{ 'form-control': styled }"
              type="text"
              :placeholder="$t('message')"
              v-model="query.then.message"
            >
            <button
              type="button"
              :class="{ 'close pull-right': styled }"
              @click="removeThen"
              v-html="labels.removeThen"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QueryBuilderRule from "./QueryBuilderRule.vue";
import deepClone from "../utilities.js";

export default {
  name: "query-builder-group",

  components: {
    QueryBuilderRule
  },

  props: [
    "ruleTypes",
    "type",
    "query",
    "rules",
    "index",
    "maxDepth",
    "depth",
    "styled",
    "labels"
  ],

  methods: {
    ruleById(ruleId) {
      var rule = null;

      this.rules.forEach(function(value) {
        if (value.id === ruleId) {
          rule = value;
          return false;
        }
      });

      return rule;
    },

    addRule() {
      let updated_query = deepClone(this.query);
      let child = {
        type: "query-builder-rule",
        query: {
          rule: this.selectedRule.id,
          selectedOperator: this.selectedRule.operators[0],
          selectedOperand:
            typeof this.selectedRule.operands === "undefined"
              ? this.selectedRule.label
              : this.selectedRule.operands[0],
          value: null
        }
      };
      // A bit hacky, but `v-model` on `select` requires an array.
      if (this.ruleById(child.query.rule).type === "multi-select") {
        child.query.value = [];
      }
      updated_query.children.push(child);
      this.$emit("update:query", updated_query);
    },

    addGroup() {
      let updated_query = deepClone(this.query);
      if (this.depth < this.maxDepth) {
        updated_query.children.push({
          type: "query-builder-group",
          query: {
            logicalOperator: this.labels.matchTypes[0].id,
            children: []
          }
        });
        this.$emit("update:query", updated_query);
      }
    },

    addThen() {
      let updated_query = deepClone(this.query);
      if (this.depth == 1) {
        updated_query.then = {
          type: "query-builder-then",
          value: "",
          message: ""
        };
        this.$emit("update:query", updated_query);
      }
    },

    remove() {
      this.$emit("child-deletion-requested", this.index);
    },

    removeThen() {
      let updated_query = deepClone(this.query);
      delete updated_query.then;
      this.$emit("update:query", updated_query);
    },

    removeChild(index) {
      let updated_query = deepClone(this.query);
      updated_query.children.splice(index, 1);
      this.$emit("update:query", updated_query);
    }
  },

  data() {
    return {
      selectedRule: this.rules[0]
    };
  },

  computed: {
    classObject() {
      var classObject = {
        mycard: this.styled
      };

      classObject["depth-" + this.depth.toString()] = this.styled;

      return classObject;
    }
  }
};
</script>
